import APIService from '../api.service';

export const ShopBalanceByShop = (params) => {
    return APIService.get(`/v01/shop-balance-by-shop`, {
        params: {
            ...params,
        },
    });
};

export const DownloadShopBalanceExport = (payload) => {
    return APIService.get('/v01/shop-balance-report-export', {
        params: {
            ...payload,
        },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
};

const ShopBalanceService = {
    ShopBalanceByShop,
    DownloadShopBalanceExport,
};

export default ShopBalanceService;
